<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-md-12 col-sm-12">

          <!-- start:: search & filters -->
          <div class="search-tool">
            <div class="row">
              <div class="col-md-4">
                <div class="input-group flex-nowrap">
                  <b-form-input
                    v-model="searchParams.serial_number"
                    type="text"
                    id="serialNumber"
                    name="serialNumber"
                    class="form-control"
                    :placeholder="$t('Search by serial number')">
                  </b-form-input>
                  <div class="input-group-append">
                    <span class="input-group-text" id="addon-wrapping"><i class="fas fa-search"></i></span>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <button type="button" id="buttonAdvancedFilters" class="btn btn-outline-primary" data-toggle="collapse" href="#advancedFilters" role="button" aria-expanded="false" aria-controls="collapseExample"><i class="fas fa-filter"></i> <span>{{$t('Advanced Search')}}</span></button>
                <button type="button" id="buttonAdvancedFiltersReset" class="btn btn-outline-secondary" href="#" role="button" @click="resetSearch"><i class="fas fa-redo"></i> <span>{{$t('Reset')}}</span></button>
                <div class="float-lg-right mt-3 mt-lg-0" v-if="canModifyColumns">
                  <button
                    type="button"
                    id="buttonModifyTableHeader"
                    class="btn"
                    href="#"
                    @click="$bvModal.show('modifyBTableHeader')">
                    <i class="fas fa-sliders-h"></i>
                  </button>
                </div>

              </div>
              <div class="col-md-12">
                <div class="collapse" id="advancedFilters">
                  <div class="card card-body advanced-filters">
                    <form>
                      <div class="row">
                        <div class="col-md-4">
                          <b-form-group :label="$t('Part number')" label-for="partNumber">
                            <b-form-input
                              type="text"
                              id="partlNumber"
                              name="partlNumber"
                              placeholder=""
                              v-model='searchParams.part_number'></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group :label="$t('Device type')" label-for="selectType">
                            <multiselect
                              id="selectType"
                              placeholder="-"
                              :searchable="false"
                              track-by="id"
                              label="commercial_name"
                              :show-no-results="true"
                              :allowEmpty="true"
                              open-direction="bottom"
                              v-model="searchParams.deviceType"
                              :options="deviceTypes"
                            >
                              <template slot="clear">
                                <div class="multiselect__clear" v-if="searchParams.deviceType" @mousedown.prevent.stop="searchParams.deviceType = null"></div>
                              </template>
                              <span slot="noOptions">
                                                                    {{ $t('No device types available') }}
                                                                </span>
                            </multiselect>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <b-form-group :label="$t('Free DGFE space')" label-for="selectDgfePercFree">
                            <multiselect
                              id="selectDgfePercFree"
                              placeholder="-"
                              :searchable="false"
                              track-by="value"
                              label="label"
                              :show-no-results="true"
                              :allowEmpty="true"
                              open-direction="bottom"
                              v-model="searchParams.dgfe_perc_free"
                              :options="dgfePercFreeOptions"
                            >
                              <template slot="clear">
                                <div class="multiselect__clear" v-if="searchParams.dgfe_perc_free" @mousedown.prevent.stop="searchParams.dgfe_perc_free = null"></div>
                              </template>
                            </multiselect>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group :label="$t('Periodic verification deadline')" label-for="selectLastVerificationDate">
                            <multiselect
                              id="selectLastVerificationDate"
                              placeholder="-"
                              :searchable="false"
                              track-by="value"
                              label="label"
                              :show-no-results="true"
                              :allowEmpty="true"
                              open-direction="bottom"
                              v-model="searchParams.last_verification_date_months"
                              :options="lastVerificationDateMonthsOptions"
                            >
                              <template slot="clear">
                                <div class="multiselect__clear" v-if="searchParams.last_verification_date_months" @mousedown.prevent.stop="searchParams.last_verification_date_months = null"></div>
                              </template>
                            </multiselect>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group :label="$t('Show discontinued devices')" label-for="show_discontinued_devices">
                            <label class="switch switch-text switch-success">
                              <input type="checkbox" id="show_discontinued_devices" name="show_discontinued_devices" v-model="searchParams.show_discontinued_devices" class="switch-input">
                              <span class="switch-label" :data-on="$t('Yes').toUpperCase()" :data-off="$t('No').toUpperCase()"></span>
                              <span class="switch-handle"></span>
                            </label>
                          </b-form-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4" v-if="!customer">
                          <b-form-group :label="$t('Customer')" label-for="customer">
                            <customer-select v-model="searchParams.customer" :with-demo="true"/>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group :label="$t('Notes')" label-for="notes">
                            <b-form-input
                              type="text"
                              id="notes"
                              name="notes"
                              placeholder=""
                              v-model='searchParams.notes'
                              :class="{ 'control': true }"></b-form-input>
                          </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group :label="$t('Labels')" label-for="label">
                            <multiselect
                              id="selectLabel"
                              label="name"
                              v-model="searchParams.labels"
                              :placeholder="$t('Search a label')"
                              track-by="id"
                              :options="labelOptions"
                              :multiple="true"
                              :taggable="true"
                            >
                                                                <span slot="noOptions">
                                                                {{ $t('No saved labels') }}
                                                                </span>
                            </multiselect>
                          </b-form-group>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end:: search & filters -->

          <b-table
            striped
            hover
            sticky-header="true"
            responsive
            ref="table"
            :current-page="pagination.currentPage"
            :per-page="pagination.perPage"
            show-empty
            :empty-text="$t('There are no records to show')"
            :empty-filtered-text="$t('There are no records matching your request')"
            :filter="filterSearch"
            :filter-debounce="500"
            :fields="fields"
            :items="devicesProvider"
            primary-key="id"
            class="table table-responsive-sm"
            sort-icon-left
            :sort-by.sync="sortParams.sortBy"
            :sort-desc.sync="sortParams.sortDesc"
            @sort-changed="onSortChanged"
            v-if="!loadingUiConfiguration">

            <template v-slot:head()="value">
              <div class="text-nowrap">{{value.label}}</div>
            </template>

            <template v-slot:cell(part_serial_number)="{ value, item }">
              <div class="text-nowrap">
                <router-link :to="{ name: 'Device detail', params: { device_id: item.id }, query: { showReturn: true }}">{{ value }}</router-link>
                <div
                  v-b-tooltip.top.dh0="{customClass: 'developmentDevice'}"
                  :title="$t('Discontinued device')"
                  v-if="item.discontinued_device"
                  class="bg-secondary d-inline-block development-dot ml-1 rounded-circle"
                />
                <div
                  v-b-tooltip.top.dh0="{customClass: 'developmentDevice'}"
                  :title="$t('Development device')"
                  v-if="item.is_dev"
                  class="bg-warning d-inline-block development-dot ml-1 rounded-circle"
                />
              </div>
            </template>
            <template v-slot:cell(customer.name)="{ value, item }">
              <div class="text-nowrap">
                {{value}}
                <div
                  v-b-tooltip.top.dh0="{customClass: 'developmentDevice'}"
                  :title="$t('Demo')"
                  v-if="item?.customer?.demo"
                  class="bg-warning d-inline-block development-dot ml-1 rounded-circle"
                />
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.dgfe_perc_free)="{ value}">
              <div class="text-nowrap">
                {{ value ? value +'%' : '' }}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.z_report_date)="{ value}">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.act_date)="{ value }">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.cert_start_date)="{ value }">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.cert_expire_date)="{ value }">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.device_reg_date)="{ value }">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>
            <template v-slot:cell(diagnostic_data.last_verification_date)="{ value }">
              <div class="text-nowrap">
                {{value | formatDatePipe($store.getters.getTimezone, 'DD-MM-YYYY')}}
              </div>
            </template>

            <template v-slot:cell(notes)="{ value }">
              <span style="font-size: 0.75rem">
                  {{value}}
              </span>
            </template>
            <template v-slot:cell(action)="row">
              <div class="action-button">
                <router-link class="btn btn-outline-primary" data-toggle="tooltip" data-placement="top" title="" :data-original-title="$t('Show')" :to="{name: 'Device detail', params: {device_id: row.item.id}, query: { showReturn: true }}">
                  <i class="fas fa-eye"></i>
                </router-link>
              </div>
            </template>

            <template v-slot:empty="scope">
              <div class="text-center text-muted my-2" v-if="loading">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{ $t("Loading...") }}</strong>
              </div>
              <div class="text-center my-2" v-else>
                {{ scope.emptyText }}
              </div>
            </template>

            <template v-slot:emptyfiltered="scope">
              <div class="text-center text-muted my-2" v-if="loading">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{ $t("Loading...") }}</strong>
              </div>
              <div class="text-center my-2" v-else>
                {{ scope.emptyFilteredText }}
              </div>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-muted my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{$t('Loading...')}}</strong>
              </div>
            </template>

          </b-table>
          <template v-else>
            <div class="text-center text-muted my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>{{ $t('Loading...') }}</strong>
            </div>
          </template>

          <table-pagination
            v-if="showPagination"
            :pagination="pagination"
            :isBusy="isBusy"
            :withChoice="true"
            :totalLabel="$t('Total items')"
          ></table-pagination>
    <BTableHeaderConfiguration
      :fieldsSettings="fieldsSettings"
      :preference-type="uiPreferenceKey"
      @changed="updateUiPreferences"
      v-if="canModifyColumns"/>


  </div>
</template>

<script>

import moment from 'moment'
import axios from 'axios'
import apiHelpers from "../../js/services/apiHelpers";
import {TablePagination} from "../../components";
import tableQuerySync from "../../js/services/tableQuerySync";
import GcsWarning from "../../components/GcsWarning.vue";
import {has} from 'lodash';
import BTableHeaderConfiguration from "../components/BTableHeaderConfiguration.vue";
import CustomerSelect from "../components/CustomerSelect.vue";

export default {
  name: 'DevicesList',
  mixins: [apiHelpers, tableQuerySync],
  components: {
    CustomerSelect,
    BTableHeaderConfiguration,
    GcsWarning,
    TablePagination
  },
  props: {
    customer: {
      type: Object,
      required: false,
      default: null
    },
    columns: {
      type: Array,
      required: false,
      default: null
    },
    canModifyColumns: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      searchParams: {
        serial_number: '',
        part_number: '',
        customer: null,
        notes: '',
        labels: [],
        deviceType: null,
        dgfe_perc_free: null,
        last_verification_date_months: null,
        show_discontinued_devices: false
      },
      sortParams: {
          sortBy: 'serial_number',
          sortDesc: false,
      },
      uiPreferenceKey: "xdealer:devices:index",
      loading: true,
      loadingUiConfiguration: true,
      fields: [],
      fieldsSettings: [
        {
          key: 'part_serial_number',
          label: this.$t("Serial number") + ' - ' + this.$t("Part number"),
          sortable: true,
          sortKey: 'serial_number',
          stickyColumn: true,
          thStyle: {minWidth: '250px'}
        },
        {
          key: 'device_type',
          label: this.$t("Device type"),
          sortable: false,
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: true
        },
        {
          key: 'update',
          label: this.$t("Update available"),
          sortable: false,
          editable: true,
          visible: true
        },
        {
          key: 'maintenance_contract_active',
          label: this.$t("Subscription"),
          sortable: false,
          editable: true,
          visible: true
        },
        {
          key: 'customer.name',
          label: this.$t("Customer"),
          sortable: true,
          sortKey: 'customers.name',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: true
        },
        {
          key: 'customer.vat_number',
          label: this.$t("VAT number"),
          sortable: true,
          sortKey: 'customers.vat_number',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.email',
          label: this.$t("Email"),
          sortable: true,
          sortKey: 'customers.email',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.phone',
          label: this.$t("Phone"),
          sortable: true,
          sortKey: 'customers.phone',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.street',
          label: this.$t("Street"),
          sortable: true,
          sortKey: 'customers.street',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.postal_code',
          label: this.$t("Postal Code"),
          sortable: true,
          sortKey: 'customers.postal_code',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.city',
          label: this.$t("City"),
          sortable: true,
          sortKey: 'customers.city',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'customer.province',
          label: this.$t("Province"),
          sortable: true,
          sortKey: 'customers.province',
          thStyle: {minWidth: '200px'},
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.dgfe_number',
          label: this.$t("DGFE"),
          sortable: true,
          sortKey: 'device_diagnostic_data.dgfe_number',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.dgfe_perc_free',
          label: this.$t("Free DGFE space"),
          sortable: true,
          sortKey: 'device_diagnostic_data.dgfe_perc_free',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.z_report_number',
          label: this.$t("Closures No."),
          sortable: true,
          sortKey: 'device_diagnostic_data.z_report_number',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.z_report_date',
          label: this.$t("Z report date"),
          sortable: true,
          sortKey: 'device_diagnostic_data.z_report_date',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.act_date',
          label: this.$t("Date of activation"),
          sortable: true,
          sortKey: 'device_diagnostic_data.act_date',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.device_reg_date',
          label: this.$t("Census date"),
          sortable: true,
          sortKey: 'device_diagnostic_data.device_reg_date',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.cert_start_date',
          label: this.$t("Date of certificate"),
          sortable: true,
          sortKey: 'device_diagnostic_data.cert_start_date',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.cert_expire_date',
          label: this.$t("Certificate expiration date"),
          sortable: true,
          sortKey: 'device_diagnostic_data.cert_expire_date',
          editable: true,
          visible: false
        },
        {
          key: 'diagnostic_data.last_verification_date',
          label: this.$t("Date of last periodic verification"),
          sortable: true,
          sortKey: 'device_diagnostic_data.last_verification_date',
          editable: true,
          visible: false
        },
        {
          key: 'notes',
          label: this.$t("Notes"),
          sortable: false,
          thStyle: {minWidth: '250px'},
          editable: true,
          visible: true
        },
        {
          key: 'action',
          label: '',
          thStyle: {minWidth: '50px'},
          sortable: false
        }
      ],
      search: null,
      labelOptions: [],
      deviceTypes: [],
      waitForLabels: true,
      waitForTypes: true,
      waitForCustomer: true,
      showPagination: false,
      dgfePercFreeOptions: [
        {value: null, label: '-'},
        {value: '10', label: 'minore del 10%'},
        {value: '20', label: 'minore del 20%'},
        {value: '30', label: 'minore del 30%'},
        {value: '40', label: 'minore del 40%'},
      ],
      lastVerificationDateMonthsOptions: [
        {value: null, label: '-'},
        {value: '1', label: 'ento 1 mese'},
        {value: '2', label: 'entro 2 mesi'},
        {value: '6', label: 'entro 6 mesi'},
      ],
    }
  },
  created(){
    if(this.customer){
      this.searchParams.customer= this.customer;
    }
  },
  mounted() {
    this.fields = this.fieldsSettings;
    this.setSearchFilter()
    this.getLabels()
    this.getDeviceTypes()
    this.loadCustomer()
    this.setColumns()
  },
  methods: {
    onSortChanged({ sortBy, sortDesc }) {
      console.log("Colonna ordinata:", sortBy);
      console.log("Ordinamento discendente?", sortDesc);
      this.sortParams.sortBy = sortBy;
      this.sortParams.sortDesc = sortDesc;
    },
    refreshTable(){
      this.$refs.table.refresh();
    },
    getDeviceTypes() {

      this.waitForTypes = !!this.$route.query['type'];

      const url = `${this.$store.getters.getAppUrl}/dealer/api/v2/device-types?sort_by=commercial_name&order_by=asc`;
      axios.get(url).then(({ data }) => {
        this.deviceTypes = data.data;

        if(this.$route.query['type']) {
          this.searchParams.deviceType = this.deviceTypes.filter(d => this.$route.query['type'] == d.id.toString())[0]
        }
      })
        .finally( () => {

          if(this.waitForTypes){
            this.waitForTypes = false;
            this.refreshTable();
          }
        });
    },
    getLabels() {

      this.waitForLabels = !!this.$route.query['labels'];

      const url = `${this.$store.getters.getAppUrl}/dealer/api/v2/labels?all=1&sort_by=name&order_by=asc`;
      axios.get(url)
        .then(({ data }) => {
          this.labelOptions = data.data;
          if(this.$route.query['labels']) {
            this.searchParams.labels = this.labelOptions.filter(d => this.$route.query['labels'].split(',').includes(d.id.toString()))
          }
        })
        .catch((error) => {
          console.log(error.stack);
        })
        .finally(() =>{

          if(this.waitForLabels){
            this.waitForLabels = false;
            this.refreshTable();
          }
        });

    },
    loadCustomer() {
      if(this.$route.query['customer_id']){
        this.waitForCustomer= true;

        let url = this.$store.getters.getAppUrl + '/dealer/api/v2/customers/' + this.$route.query['customer_id']
        axios.get(url)
          .then(({ data }) => {
            this.searchParams.customer = data.data;
          })
          .catch((error) => {
            console.log(error.stack);
          })
          .finally(() => {

            if(this.waitForCustomer){
              this.waitForCustomer= false;
              this.refreshTable();
            }
          });
      }else{
        this.waitForCustomer= false;
      }

    },
    setColumns(){
      if(this.columns){

        this.fields= [];
        this.fields.push(this.fieldsSettings.find(entry => entry.key === 'part_serial_number'));

        this.columns.forEach(key => {

          let obj = this.fieldsSettings.find(entry => entry.key === key)
          if(obj){
            obj.visible= true;
            this.fields.push(obj);
          }
        });

        this.loadingUiConfiguration= false;
      }
    },
    setSearchFilter(){
      Object.keys(this.$route.query).forEach(key => {
        if(has(this.searchParams, key) && key !== 'labels' && key !== 'type') {
          if(key === 'dgfe_perc_free') {
            this.searchParams.dgfe_perc_free = this.dgfePercFreeOptions.filter(item => this.$route.query['dgfe_perc_free'] == item.value?.toString())[0]
          }else if(key === 'last_verification_date_months'){
            this.searchParams.last_verification_date_months = this.lastVerificationDateMonthsOptions.filter(item => this.$route.query['last_verification_date_months'] == item.value?.toString())[0]
          }else if(key === 'show_discontinued_devices'){
            this.searchParams.show_discontinued_devices= (this.$route.query[key] == 1)
          }else{
            this.searchParams[key] = this.$route.query[key];
          }
        }
      })
    },
    devicesProvider(ctx) {
      if (!this.waitForLabels
        && !this.waitForTypes
        && !this.waitForCustomer){
        const url = `${this.$store.getters.getAppUrl}/dealer/api/v2/devices?1=1`;
        return axios.get(url, {
          params: this.preparePaginationQuery(ctx, 'dealer-devices.customer,purchased_version,is_replaced_by,diagnostic_data')
        }).then(({ data }) => {
          this.updatePaginationMeta(data);
          this.showPagination = true;
          return this.parseResponseData(data.data);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    parseResponseData(list) {
      const $t = this.$t.bind(this);
      return list.map( device => {
        let update;
        if(device.bundle_devices_updates){
          update = device.bundle_devices_updates? $t('Yes') : $t('No');
        }
        else{
          const hasUpdate = device.has_update || device.purchased_version;
          const hasFiscalUpdate = device.has_fiscal_updates && device.available_version_fiscal_update;

          update = $t('No');

          if((hasUpdate || hasFiscalUpdate) && !device.is_replaced_by) {
            update = $t('Yes');

            const version = device.has_update
              ? device.available_version
              : device.purchased_version

            if(version) {
              update = `${update} [ version ${version} ]`;
            }

            if(hasFiscalUpdate) {
              update = `${update} [ firmware version ${device.available_version_fiscal_update} ]`;
            }
          }
        }

        return {
          part_serial_number: device.serial_number + (device.part_number ? ' - ' + device.part_number : ''),
          //customer: device.customer_name || '',
          update,
          maintenance_contract_active: device.has_maintenance_contract ?  `${$t('Yes')}` :  `${$t('No')}`,
          ...device
        }
      });
    },
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD hh:mm:ss').format('DD-MM-YYYY')
    },
    resetSearch($event) {
      this.searchParams.part_number = '';
      this.searchParams.serial_number = '';
      this.searchParams.customer = null;
      this.searchParams.notes = '';
      this.searchParams.labels = [];
      this.searchParams.deviceType = null;
      this.searchParams.dgfe_perc_free = null;
      this.searchParams.last_verification_date_months = null;
      this.searchParams.show_discontinued_devices = false;

      this.search = null;
      this.pagination.currentPage = 1;
    },
    updateUiPreferences(newFields) {
      this.fields = newFields;
      this.loadingUiConfiguration= false;
    },

  },
  watch: {
      searchParams: {
          handler(newValue) {
              //this.$emit("search-params-updated", newValue);
              this.$emit("filter-params-updated", {'searchParams': newValue, 'sortParams': this.sortParams});
          },
          deep: true,
      },
      sortParams: {
          handler(newValue) {
              this.$emit("filter-params-updated", {'searchParams': this.sortParams, 'sortParams': newValue});
          },
          deep: true,
      },
  },
  computed: {
    filterSearch() {

      const params = {};

      if (this.searchParams.serial_number !== "") {
        params.serial_number = this.searchParams.serial_number;
      }
      if (this.searchParams.part_number !== "") {
        params.part_number = this.searchParams.part_number;
      }
      if (this.searchParams.customer != null ) {
        params.customer_id = this.searchParams.customer.id;
      }

      if (this.searchParams.notes !== "") {
        params.notes = this.searchParams.notes;
      }
      if (this.searchParams.labels.length > 0) {
        params.labels = this.searchParams.labels.map(({ id }) => id).join(",")
      }
      if (this.searchParams.deviceType) {
        params.type = this.searchParams.deviceType.id.toString()
      }
      if (this.searchParams.dgfe_perc_free) {
        params.dgfe_perc_free = this.searchParams.dgfe_perc_free.value.toString()
      }
      if (this.searchParams.last_verification_date_months?.value) {
        params.last_verification_date_months = this.searchParams.last_verification_date_months.value.toString()
      }
      params.show_discontinued_devices = this.searchParams.show_discontinued_devices? 1 : 0;

      this.search = params
      return params;
    }
  }
}
</script>

<style lang="css">
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  border-collapse: collapse;
}
.table-responsive .b-table-sticky-column{
  position: relative !important;
}
@media (min-width: 992px) {
  .table-responsive .b-table-sticky-column{
    position: sticky !important;
    left:0;
    z-index: 2;
  }
  .table.b-table.table-striped > tbody > tr:nth-of-type(2n+1) > .table-b-table-default.b-table-sticky-column {
    background-image: none;
    background-color: #F3F4F6;
  }
  .table.b-table.table-striped > tbody > tr:hover > .table-b-table-default.b-table-sticky-column {
    background-image: none;
    background-color: #FFF;
  }
  td.b-table-sticky-column:after,
  th.b-table-sticky-column:after,
  td.b-table-sticky-column:before,
  th.b-table-sticky-column:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
  }
  td.b-table-sticky-column:before, th.b-table-sticky-column:before {
    top: -1px;
    border-top: 1px solid #D0D3D9;
  }
  tr:first-child td.b-table-sticky-column:before {
    top: -2px;
    border-top: 2px solid #D0D3D9;
  }
  td.b-table-sticky-column:after {
    bottom: -1px;
    border-bottom: 1px solid #D0D3D9;
  }
  tr:last-child td.b-table-sticky-column:after {
    border-bottom: 0;
  }
}
/*
tr:hover td.b-table-sticky-column{
    background-color: #fff !important;
    background-image: none !important;
}*/
.table-responsive.table-bordered {
  border: 0;
}
.b-table-sticky-header{
  max-height: none;
}
.b-table > thead > tr > th[aria-sort]::before,
.b-table > thead > tr > th[aria-sort]::after,
.b-table > tfoot > tr > th[aria-sort]::before,
.b-table > tfoot > tr > th[aria-sort]::after
{
  left: auto;
  width: auto;
  top: auto;
  border: 0;
}

.developmentDevice.tooltip{
  opacity: 1 !important;
  top:-2px !important;
}
.developmentDevice .tooltip-inner {
  background-color: #4B5563 !important;
}
.developmentDevice.tooltip.bs-tooltip-top .arrow::before, .developmentDevice.tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-top-color: #4B5563 !important;
}
</style>
